import { State } from 'store/reducers/ui';
import dark from '../styles/themes/dark.module.scss';
import light from '../styles/themes/light.module.scss';

export const applyTheme = (darkMode: boolean, customThemes: State['themes']): void => {
  const theme = darkMode ? dark : light;
  const custom = darkMode ? customThemes.dark : customThemes.light;


  Object.keys(theme).forEach((key) => {
    if (custom && custom[key]) {
      document.documentElement.style.setProperty(key, custom[key]);

      return;
    }

    document.documentElement.style.setProperty(key, theme[key]);
  });

  if (customThemes.fontFamily) {
    document.documentElement.style.setProperty('--font-family', customThemes.fontFamily);
  } else {
    //default font family
    document.documentElement.style.setProperty('--font-family', '\'Nunito Sans\', sans-serif');
  }
};